import React, { useState, useEffect } from "react";

import Details from "./help/Details";
import Form from "./help/Form";
import List from "./help/List";

import axiosInstance from 'utils/axiosInstance';
import { useLocalStorage } from 'utils/storage';

import { fetchGroups } from "services/groups";

const Groups = ({
    setShowContent
}) => {
    const [currentState, setCurrentState] = useState('list');

    const [groups, setGroups] = useLocalStorage('groups', []);

    const [itemToEdit, setItemToEdit] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleFormSubmit = async (form) => {
        try {
            let response;

            if (form.uid) {
                response = await axiosInstance.post(`/api/groups/${form.uid}`, form);
            } else {
                response = await axiosInstance.post("/api/groups", form);
            }

            const itemInResponse = response.data.data;

            setGroups((currentItems) => {
                const isEditing = currentItems.some(n => n.uid === itemInResponse.uid);

                if (isEditing) {
                    return currentItems.map(item =>
                        item.uid === itemInResponse.uid ? itemInResponse : item
                    );
                } else {
                    return [...currentItems, itemInResponse];
                }
            });

            setCurrentState('list');
        } catch (error) {
            console.error('Failed to save group:', error);
        }
    };

    const handleDelete = async (uid) => {
        try {
            await axiosInstance.delete(`/api/groups/${uid}`);

            setGroups((groups) => groups.filter(n => n.uid !== uid));

            if (currentState !== 'list') {
                setCurrentState('list');
            }
        } catch (error) {
            console.error('Failed to delete group:', error);
        }
    };

    const handleReorder = async (items) => {
        try {
            await axiosInstance.post('/api/groups/change-order', {
                groups: items.map(({ uid, order }) => ({ uid, order })),
            });

            setGroups(items);
        } catch (error) {
            console.error('Failed to change order:', error);
        }
    };
    
    useEffect(() => {
        fetchGroups().then((data) => {
            if (data) {
                setGroups(data);
            }
        });
    }, []);


    const handleOpenDetails = async (item) => {
        setSelectedItem(item);
        setCurrentState('details');
    }

    const handleCloseDetails = () => {        
        setSelectedItem(null);
        setCurrentState('list');
    }

    const handleEdit = (group) => {
        setItemToEdit(group);
        setCurrentState('edit');
    };

    const handleFormCancel = () => {
        setItemToEdit(null);
        setCurrentState('list');
    }

    const handleBackButton = () => {
        setShowContent(false);
    }

    const renderCurrentView = () => {
        switch (currentState) {
            case "list":
                return (
                    <List
                        items={groups}
                        onClickHandler={handleOpenDetails}
                        onDeleteHandler={handleDelete}
                        onEditHandler={handleEdit}
                        onReorderHandler={handleReorder}
                        onBackClick={handleBackButton}
                        setCurrentState={setCurrentState}
                    />
                );
            case "details":
                return (
                    <Details
                        item={selectedItem}
                        onEditHandler={handleEdit}
                        onDeleteHandler={handleDelete}
                        onCloseHandler={handleCloseDetails}
                    />
                );
            case "add":
            case "edit":
                return (
                    <Form
                        itemToEdit={itemToEdit}
                        onFormSubmit={handleFormSubmit}
                        onCancelHandler={handleFormCancel}
                    />
                );
            default:
                return <div>Unknown state</div>;
        }
    };

    return (
        renderCurrentView()
    );
};

export default Groups;
